import React from "react";
import styled from "styled-components";

import { DropDownArrow } from "../../../SVGS";
// import Avatar from "../Avatar/Avatar";

const ContentRendererStyles = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .contentContainer {
    display: flex;
    align-items: center;
    margin: 0 !important;
  }

  .value {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    letter-spacing: -0.01em;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .placeholder {
    opacity: 0.5;
    color: ${({ theme }) => theme.colors.semantic.text.strong} !important;
  }

  .arrowContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(-180deg);
  }
`;

const contentRenderer = ({ props, state }) => {
  return (
    <ContentRendererStyles>
      <div className="contentContainer" style={{ height: props.size }}>
        {props.withImage && props.Icon && props.Icon}
        <div style={{ marginLeft: props.Icon ? 10 : 0 }}>
          <p
            className={`value ${
              !!state.values.length === false && "placeholder"
            }`}
          >
            {!props.alwayClearInput && state.values.length > 0
              ? state.values[0].label
              : props.placeholder}
          </p>
          <p
            className={`value ${
              !!state.values.length === false && "placeholder"
            }`}
            style={{ opacity: 0.4 }}
          >
            {state.values.length > 0 && state.values[0].label1}
          </p>
        </div>
      </div>
      <div className="arrowContainer">
        <DropDownArrow />
      </div>
    </ContentRendererStyles>
  );
};

export default contentRenderer;
